
// vue
import { defineComponent, PropType, reactive } from 'vue';

interface Option {
  label: string;
  val: number;
}

export default defineComponent({
  name: 'SelectBox',
  props: {
    options: {
      type: Array as PropType<Option[]>,
      required: true,
    },
    selectedVal: {
      type: String,
      required: false,
      defaultVal: '',
    },
    fontSize: {
      type: String,
      required: false,
      defaultVal: '',
    },
  },
  setup(props) {
    const styles = reactive({}) as { [key: string]: any };
    if (props.fontSize) {
      styles.fontSize = props.fontSize;
    }

    return {
      styles,
    };
  },
});
